import Typed from "typed.js";
import { useEffect, useRef } from "react";
import '@fortawesome/fontawesome-free/css/all.css';
const Body = () => {
  const el = useRef(null);
  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: ["A CS Student", "A Problem Solver", " A Web Developer"],
      startDelay: 60,
      typeSpeed: 60,
      backSpeed: 60,
      backDelay: 60
    })
    return () => {
      typed.destroy();
    }
  }, []);
  return (
    <div className="flex justify-around my-20 mx-auto p-4 text-white rounded-bl-3xl w-9/12">
      <div className=" relative top-20 text-left text-5xl">
        <div className="font-custom">
          <p className="mb-4">I am Aman</p>
          <span ref={el}></span>
        </div>
        <div className="text-xl my-10">
          <a href="/cv.pdf" download="Resume" target="_blank" rel="noreferrer"><button className="bg-violet-700 rounded-md p-4 mr-2">Download CV</button></a>
          <button className="bg-violet-700 rounded-md p-4" onClick={() => window.scrollTo({ top: 1400, behavior: "smooth" })}>Contact Me</button>
        </div>
        <div>
          <i className="fa-brands fa-twitter mr-4"></i>
          <i className="fa-brands fa-github"></i>
          <p className="w-8/12 text-base my-8">Currently pursuing a bachelors from Birla Institute of Technology.Completed my Schooling from St karens High School.
            Besides adding colors to buttons,I like to watch cricket in my free time.</p>
        </div>
      </div>
      <div className="relative top-10">
        <img src="https://i.ibb.co/cg0hd7G/Screenshot-from-2024-01-19-00-27-02.png" alt="Display picture" />
      </div>
    </div>
  );
}
export default Body;
